import React from 'react'

import theme from 'theme'

type BooleanFieldProps = {
  currentValue: boolean
  onText?: string
  offText?: string
}

const BooleanField: React.FC<BooleanFieldProps> = ({
  currentValue,
  children,
  onText = 'On',
  offText = 'Off'
}) => {
  return (
    <div
      css={{
        display: 'grid',
        gridAutoColumns: 'auto',
        gridAutoFlow: 'column',
        justifyContent: 'start',
        gap: theme.space[3],
        alignItems: 'center'
      }}
    >
      <div
        css={{
          color: theme.colors.steel[1],
          fontWeight: 'normal'
        }}
      >
        {currentValue ? onText : offText}
      </div>
      {children}
    </div>
  )
}

export default BooleanField
